module.exports = __webpack_public_path__ + "img/icon-checkbox.062e6a10.svg";